module.exports = __webpack_public_path__ + "public/media/FROZY-TWIST.png";


//////////////////
// WEBPACK FOOTER
// ./images/partners/FROZY-TWIST.png
// module id = ./images/partners/FROZY-TWIST.png
// module chunks = 0